import { Subject } from '@reactivex/rxjs';

export function createSubject() {
    return new Subject();
}
